<div ngbDropdown placement="bottom-right" #columnsDropdown="ngbDropdown" container="body">
    <button class="btn btn-info" id="columnMenu" ngbDropdownToggle (click)="dropdownToggle()">
        <i class="fa fa-table-columns"></i><span class="ms-1">{{ 'columns' | translate }}</span>
    </button>
    <div ngbDropdownMenu aria-labelledby="columnMenu" class="column-menu p-2">
        <form #f='ngForm'>
            <div class="inner-addon right-addon mb-2">
                <i class="fa fa-search"></i>
                <input type="text" class="form-control" placeholder="{{ 'inventoryManagerApp.lot.buttons.search' | translate }}" (keyup)="onSearchColumn($event)" />
            </div>
            <div class="columns-container custom-scroll-style">
                <div>
                    <div class="form-check" *ngFor="let column of this.staticColumns">
                        <div *ngIf="column.visible">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="column.selected"
                                   id="check-static-{{column.id}}" name="'check-static-{{column.id}}'">
                            <label class="form-check-label" for="check-static-{{column.id}}" jhiTranslate="{{column.displayName}}">
                                {{column.displayName}}
                            </label>
                        </div>
                    </div>
                </div>

                <div class="mt-3">
                    <label class="form-check-label fw-bold" jhiTranslate="inventoryManagerApp.lot.source.title">SOURCE LOT</label>
                    <hr class="mt-1 mb-1" />
                    <div class="form-check" *ngFor="let column of this.lotSourceColumns">
                        <div *ngIf="column.visible">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="column.selected"
                                   id="check-static-{{column.id}}" name="'check-static-{{column.id}}'">
                            <label class="form-check-label" for="check-static-{{column.id}}" jhiTranslate="{{column.displayName}}">
                                {{column.displayName}}
                            </label>
                        </div>
                    </div>
                </div>

                <div *ngIf="this.checkAreColumnsVisible(this.lotAttributeColumns)" class="mt-3">
                    <label class="form-check-label fw-bold" jhiTranslate="inventoryManagerApp.lot.attributes.title">ATTRIBUTES</label>
                    <hr class="mt-1 mb-1" />
                    <div class="form-check" *ngFor="let column of this.lotAttributeColumns">
                        <div *ngIf="column.visible">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="column.selected"
                                   id="check-attributes-{{column.id}}" name="'check-attributes-{{column.id}}'">
                            <label class="form-check-label" for="check-attributes-{{column.id}}">
                                {{column.displayName}}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="mt-3 mb-0" />
            <div class="text-center" data-test="columnsApplyButton"><br>
                <button type="submit" class="btn btn-primary btn-sm" (click)="apply()" jhiTranslate="apply">Apply</button>
            </div>
        </form>
    </div>
</div>
